/**
 * Constantes del feature "colas" (turnos de mostrador)
 */
import { BADGE_COLORS } from "../../components/ui/badgeColors";
import { ORDER_STATE } from "../../config/constants";

// Valores en minúscula EXACTOS que emite el backend
// (api/src/constants/entradas_cola.constans.js)
export const ENTRADA_ESTADO = {
    ESPERANDO: "esperando",
    LLAMADO: "llamado",
    FINALIZADO: "finalizado",
    SALTADO: "saltado",
};

// Etiqueta y color de badge por estado. Equivalencia semántica con el CBadge
// legacy: secondary -> GRAY, info -> BLUE, success -> GREEN, danger -> RED
export const ETIQUETAS_ENTRADA_ESTADO = {
    [ENTRADA_ESTADO.ESPERANDO]: { label: "Esperando", color: BADGE_COLORS.GRAY },
    [ENTRADA_ESTADO.LLAMADO]: { label: "Llamado", color: BADGE_COLORS.BLUE },
    [ENTRADA_ESTADO.FINALIZADO]: { label: "Finalizado", color: BADGE_COLORS.GREEN },
    [ENTRADA_ESTADO.SALTADO]: { label: "Saltado", color: BADGE_COLORS.RED },
};

// Marca que lleva `numero` cuando la entrada no tiene pedido (SIN_PEDIDO del backend)
export const ENTRADA_SIN_PEDIDO_MARCA = "SP";

// Claves de localStorage idénticas a las del legacy, para no perder la
// selección de cada puesto de trabajo al desplegar
export const CLAVE_MOSTRADOR = "mostrador";
export const CLAVE_EMPLEADO = "empleadoId";

// Longitud máxima del nombre de una cola (validación del modal de alta/edición)
export const NOMBRE_COLA_MAX = 100;

// Eventos de socket que emite el backend a la sala `cola:<id>`
// (api/src/services/entradas_cola.service.js)
export const TURNO_EVENTO = {
    LLAMADO: "turno:llamado",
    ESPERANDO: "turno:esperando",
    FINALIZAR: "turno:finalizar",
    SALTAR: "turno:saltar",
    ELIMINAR: "turno:eliminar",
};

// Máximo de turnos que muestra "Últimos llamados" en la pantalla pública
export const PANTALLA_LLAMADOS_MAX = 5;

// Color del badge de un pedido según su estado de preparación (ORDER_STATE no es secuencial)
export const COLOR_ESTADO_PEDIDO = {
    [ORDER_STATE.SIN_PREPARAR]: BADGE_COLORS.BLUE,
    [ORDER_STATE.EN_PREPARACION]: BADGE_COLORS.RED,
    [ORDER_STATE.EN_REVISION]: BADGE_COLORS.AMBER,
    [ORDER_STATE.PREPARADO]: BADGE_COLORS.GREEN,
};

// Formato 'serie-numero' del pedido (ej. 01-123): exactamente un guion, partes no vacías
export const PEDIDO_FORMATO = /^[^-\s]+-[^-\s]+$/;
